import parsePhoneNumber from 'libphonenumber-js'

export const formatPhoneNumber = (phone: string) => {
  if (!phone || phone?.length < 3) {
    return ''
  } else {
    const phoneNumber = parsePhoneNumber(phone)

    return phoneNumber?.formatInternational()
  }
}
